import IncognitoModeError from './IncognitoModeError';

export default IncognitoModeError;
